import React from "react";

export const useValidateProductionInputs = (config_inputs, inputs_for_validate) => {
  const error_list = [];
  const aux_values = ["No material", "No Equipment", "No_Block_Name", "No material class", "Without factor"];
  for (const [key, value] of Object.entries(inputs_for_validate)) {
    const config = config_inputs[key];
    //console.log(config)

    // Si no está definido en config_inputs, es obligatorio
    if (config === undefined || config?.is_show === true) {
      if (value === undefined || value === null || value === "" || aux_values.includes(value.label)) {
        error_list.push(`${key} error`);
        continue;
      }
    }
  }
  return error_list;
};
